import { config } from '@thisisdevelopment/akzonobel-core';

const cdnUrl = (filename: string) =>
  `https://djytrhdojvgoq.cloudfront.net/${config.domainCode}/test/uploads/originals/${filename}`;

const groups = [
  {
    name: 'colour group',
    path: 'hue[0].global',
    items: [
      {
        name: 'Cool Neutral',
        headerImage: cdnUrl('cool-neutral.jpg'),
        description: '',
      },
      {
        name: 'Warm Neutral',
        headerImage: cdnUrl('warm-neutral.jpg'),
        description: '',
      },
      {
        name: 'White',
        headerImage: cdnUrl('white.jpg'),
        description: '',
      },
      {
        name: 'Orange',
        headerImage: cdnUrl('orange.jpg'),
        description: '',
      },
      {
        name: 'Yellow',
        headerImage: cdnUrl('yellow.jpg'),
        description: '',
      },
      {
        name: 'Green',
        headerImage: cdnUrl('green.jpg'),
        description: '',
      },
      {
        name: 'Blue',
        headerImage: cdnUrl('blue.jpg'),
        description: '',
      },
      {
        name: 'Red',
        headerImage: cdnUrl('red.jpg'),
        description: '',
      },
      {
        name: 'Violet',
        headerImage: cdnUrl('violet.jpg'),
        description: '',
      },
      {
        name: 'Lime',
        headerImage: cdnUrl('lime.jpg'),
        description: '',
      },
      {
        name: 'Teal',
        headerImage: cdnUrl('teal.jpg'),
        description: '',
      },
    ],
  },
  {
    name: 'tone',
    path: 'sensation',
    items: [
      {
        name: 'Pale Tones',
        headerImage: cdnUrl('pale-tones.jpg'),
        description:
          'These shades bring a light and airy feel to a space or can be used against mid or deep tones to \u2018lift\u2019 ceilings and woodwork.',
      },
      {
        name: 'Mid Tones',
        headerImage: cdnUrl('mid-tones.jpg'),
        description:
          'Choose one of these shades to create a cosy and comfortable space; they pair beautifully with a white or pale tone for a softer look.',
      },
      {
        name: 'Deep Tones',
        headerImage: cdnUrl('deep-tones.jpg'),
        description:
          'Make an impact with one of these colours across all walls or use them, balanced with a subtle white, to enhance a focal point.',
      },
      {
        name: 'Whites',
        headerImage: cdnUrl('white-tones.jpg'),
        description:
          'These whites have been specially selected to coordinate effortlessly with the other tones in the same column of colour, whether for your woodwork, walls or ceilings.',
      },
    ],
  },
  {
    name: 'colour wall',
    path: '',
    items: [],
  },
];

export default groups;
